/* tslint:disable */
/* eslint-disable */

import { ReaderInlineDataFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type useIsOnline_viewer = {
    readonly presenceFeatureFlag: boolean | null;
    readonly presenceRolloutPercentage: string | null;
    readonly " $refType": "useIsOnline_viewer";
};
export type useIsOnline_viewer$data = useIsOnline_viewer;
export type useIsOnline_viewer$key = {
    readonly " $data"?: useIsOnline_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"useIsOnline_viewer">;
};



const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "useIsOnline_viewer"
};
(node as any).hash = 'f6cf6c2de494422641b9cc7446c47bdb';
export default node;
